import { createApiInstance, RetryPolicy } from "./apiClient";

const authenticationUrl = process.env.REACT_APP_IDP_URL;

const ProfileFallbackMessage = "Something went wrong. Please try again or contact support.";

const profileFailureMessage = (error) => {
	const status = error.response?.status;
	if (status !== 400 && status !== 404 && status !== 409) return ProfileFallbackMessage;

	return error.response?.data?.errors?.[0]?.message ?? ProfileFallbackMessage;
};

export const putCompleteProfileData = async (data) => {
	try {
		const instance = createApiInstance({ baseURL: `${authenticationUrl}/api/authentication/`, retry: RetryPolicy.RateLimitedOnly });

		const bodyData = {
			firstName: data.firstName,
			lastName: data.lastName,
			phone: data.mobile,
			wholesaleTrader: data.wholesaleTrader,
			personalIdNumber: data.personalIdNumber,
			companyRegNo: data.companyRegNo
		};

		const requestUrl = `update-profile`;

		return await instance
			.put(requestUrl, bodyData)
			.then((response) => {
				return {
					error: response.data.error,
					success: response.data.success,
					message: response.data.message
				};
			})
			.catch((error) => {
				if (error.response) {
					console.error("Server Error:", error.response.status);
				}
				else if (error.request) {
					console.error("Network Error:", error.request);
				}
				else {
					console.error("Error:", error.message);
				}

				return {
					error: true,
					success: false,
					message: profileFailureMessage(error)
				};
			});
	}
	catch (e) {
		return {
			error: true,
			success: false,
			message: ProfileFallbackMessage
		};
	}
};
